enum BulletPointsColsEnum {
  COL_1 = 1,
  COL_2 = 2,
  COL_3 = 3,
  COL_4 = 4,
}

type BulletPointsCols =
  | BulletPointsColsEnum.COL_1
  | BulletPointsColsEnum.COL_2
  | BulletPointsColsEnum.COL_3
  | BulletPointsColsEnum.COL_4;

enum AnchorTargetEnum {
  BLANK = '_blank',
  SELF = '_self',
}
enum RelValueEnum {
  NOOPENER = 'noopener',
}

export { BulletPointsCols, BulletPointsColsEnum, AnchorTargetEnum, RelValueEnum };
